import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect } from 'react-redux'

import { IRootState } from '../../common/reducers'
import { ILocationParams } from '../../common/reducers/reactRouterLocation'
import { hasFeature } from '../../common/utils/features'
import makeSearchLink from '../../common/utils/location/makeSearchLink'
import { makeLink } from '../../common/utils/urlHelper'
import SearchLink from '../components/searchLink'

interface IOwnProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  locationParams: ILocationParams
  hash?: string
}

interface IStateProps {
  makeSearchLink: (params: ILocationParams) => string
  currentSite: Site
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const { common: { currentSite }, router: { location }, experiments } = state

  const newRoutesEnabled = hasFeature(
    'routes:new',
    currentSite,
    location,
    experiments
  )

  return {
    makeSearchLink: newRoutesEnabled ? makeSearchLink : makeLink,
    currentSite
  }
}

const mapDispatchToProps = () => {
  return {}
}

const SearchLinkContainer = connect<IStateProps, void, IOwnProps, IRootState>(
  mapStateToProps,
  mapDispatchToProps
)(SearchLink)

export default SearchLinkContainer
